<template>
    <div class="popup__block">
        <div class="popup__tab" data-tabs="popup__content--login">
            <div class="popup__tab-item active">Авторизация</div>
            <div class="popup__tab-item">Регистрация</div>
        </div>
        <div class="popup__content popup__content--login">
            <auth-form></auth-form>
            <registration-form></registration-form>
        </div>
    </div>
</template>

<script>
import AuthForm from "./AuthForm";
import RegistrationForm from "./RegistrationForm";
export default {
    name: "AuthPopup",
    components: {
        AuthForm, RegistrationForm
    },
}
</script>

<style scoped>

</style>